import { createHeadersForValue } from './createHeadersForValue';

export const createHeaders = (
  headers: Record<string, string | number | undefined>,
): ReturnType<typeof createHeadersForValue> =>
  Object.entries(headers).reduce(
    (acc, [key, value]) => ({ ...acc, ...createHeadersForValue(key, value) }),
    {},
  );
